import {
  DeviceSpecificationContentModel,
  DeviceSpecificationUnifyContentPackageType,
} from '../generated/types/DeviceSpecificationContentModel';

const DeviceSpecificationContentMock: DeviceSpecificationUnifyContentPackageType = {
  device_specification: [
    {
      metadata: {},
      title: '[M]title',
      identifier: {
        metadata: {},
        identifier: 'Marsden_M_550',
      },
      sensor_type: '[M]sensor_type',
      manufacturer: '[M]manufacturer',
      device_model: '[M]device_model',
      sensor_image: {
        metadata: {},
        image: {
          metadata: {},
          _version: 0,
          uid: '[M]sensor_image.image.uid',
          title: '[M]sensor_image.image.title',
          filename: '[M]sensor_image.image.filename',
          relative_path: '[M]sensor_image.image.relative_path',
          content_type: '[M]sensor_image.image.content_type',
          file_size: '[M]sensor_image.image.file_size',
          url: 'https://d1cr4mo06ywth1.cloudfront.net/unify/master/unify/master/fec2c433c7c27792ace3/sensorImage.png?Expires=1723204956&Signature=EuL5wC6-6sQPFuWFTosvC8sUIU~MRRWgzR~yDsuvYcQEyph8mzV5ZPjxLqiORNrtwlqPx3GCPhak5xLmIUwGGybWdeh6hMnnEs1hThWFkPzWOZyCwLloagHkbagvZMsauCKQR78f4TKWTZBUCvKxoedEHbOfUWR2dNzTbHynmzXjqMRZA8YPpsTmCnGM6b8E9c0GhABSYGvnVHfNWrBmjddZ04syulpu3sDflwhfvv8LZGPLOXaZFPsadQIDUttTIYupH2-s28Xr-OK7Ueivg2VDMPmLghrOoq5bMbUQkpOta0gW7049J29v2jJ-3yAjfjX4s5bwq80PAhaTGwuXeA__&Key-Pair-Id=APKAJAG7CPDF7XZTD6SA',
          tags: ['[M]sensor_image.image.tags'],
        },
        alt_text: '[M]sensor_image.alt_text',
      },
      units: [
        {
          metadata: {},
          unit_key: '[M]units.unit_key',
          unit_label: '[M]units.unit_label',
        },
      ],
      table_columns: [
        {
          metadata: {},
          column_key: '[M]table_columns.column_key',
          column_label: '[M]table_columns.column_label',
        },
      ],
      table_units: [
        {
          metadata: {},
          value_name: '[M]table_units.value_name',
          units: [
            {
              metadata: {},
              unit_key: '[M]table_units.units.unit_key',
              unit_label: '[M]table_units.units.unit_label',
            },
          ],
        },
      ],
      uid: '[M]uid',
      _content_type_uid: 'device_specification',
    },
    {
      metadata: {},
      title: 'VivaLNK Multi-vital patch',
      identifier: {
        metadata: {},
        identifier: 'VivaLNK_VV330_C8',
      },
      sensor_type: 'Multi-vital patch',
      manufacturer: 'VIVALINK',
      device_model: 'VivaLNK_VV330_C8',
      sensor_image: {
        metadata: {},
        image: {
          metadata: {},
          _version: 0,
          uid: 'null',
          title: 'OFRAZU 12840_Device_Small 1.png',
          filename: 'OFRAZU 12840_Device_Small 1.png',
          relative_path: '[M]sensor_image.image.relative_path',
          content_type: 'image/png',
          file_size: '36369',
          url: 'https://d1cr4mo06ywth1.cloudfront.net/unify/master/unify/master/e091d2bfca26eb4cef50/sensorImage.png?Expires=1723798222&Signature=L2qHExjAOlTv~eQaZb9TpvB3MO9d3kmXFnYjcqfhAIzIBN~X97OOdSlVc0RZhvNJz2yOJ311LyeRQIXac8MUJlq8T5ORQNw01DI1CSxPb8udYuS2jqhWGZBsnYg6hty3WRyYl9dtb6uBwzeqqgmbDVKSDphjl-Gp9RFeNRbTVHsnHViVtJjLs6GJKQmSVr3nkQa~9vwRuhUKihz9SsUVq~hvM2-Kdpi6SnhPVm~CJtQhFTpj5bSwGcD1WngFDCEaFxRZvse6xVOD8T-1dE1nDucPvoV47fSd-DSPxEhG4TgjDmn88LMbrYfmGWoaRar-hl62AwHIp4ZSXtowPOmMmQ__&Key-Pair-Id=APKAJAG7CPDF7XZTD6SA',
          tags: ['[M]sensor_image.image.tags'],
        },
        alt_text: '[M]sensor_image.alt_text',
      },
      units: [
        {
          metadata: {},
          unit_key: '[M]units.unit_key',
          unit_label: '[M]units.unit_label',
        },
      ],
      table_columns: [
        {
          metadata: {},
          column_key: 'HEART_RATE',
          column_label: 'HR Last',
        },
        {
          column_key: 'RESPIRATION_RATE',
          column_label: 'RR Last',
        },
        {
          column_key: 'HRV',
          column_label: 'HRV',
        },
      ],
      table_units: [
        {
          metadata: {},
          value_name: 'heart_rate',
          units: [
            {
              metadata: {},
              unit_key: 'bpm',
              unit_label: 'bpm',
            },
          ],
        },
        {
          metadata: {},
          value_name: 'respiration_rate',
          units: [
            {
              metadata: {},
              unit_key: 'rpm',
              unit_label: 'rpm',
            },
          ],
        },
      ],
      uid: '[M]uid',
      _content_type_uid: 'device_specification',
    },
    {
      metadata: {},
      title: 'Omron 9200T',
      identifier: {
        metadata: {},
        identifier: 'HEM-9200T',
      },
      sensor_type: 'Blood Pressure',
      manufacturer: 'OMRON',
      device_model: 'HEM-9200T',
      sensor_image: {
        metadata: {},
        image: {
          metadata: {},
          _version: 0,
          uid: 'null',
          title: 'Device_Photograph_OmronHEM-9200T_v01.jpg',
          filename: 'Device_Photograph_OmronHEM-9200T_v01.jpg',
          relative_path: '[M]sensor_image.image.relative_path',
          content_type: 'image/jpeg',
          file_size: '17143',
          url: 'https://d1cr4mo06ywth1.cloudfront.net/unify/master/unify/master/256b6a6f1580aad2ca1b/sensorImage.jpg?Expires=1723798222&Signature=Pd0jD~YvK-rdyvd-jpYcxCP-QSZph4nM4d4ocssx8h0JuJfcmbosDCfhye-ATaAWy8YSpo67y6ZhgSnaDRVSNk-TNdGYyM6HpoMeN0tksSl55iUBv1TM-fi-VUE7d2Adf4BoPk~58Gb6RoJV1A-d0U~CX-L2o~oz-BhAIcyKLutkhtZRd85~gbAS5VbXHpW0XdICuBkGkgRTMDKBZSkqSlXLD8tGvZ7Dwu7YYE0nyVXtleFKpIn5Br7uxZpXx5U94tXhJgjpxssRkKEyQJPJGJ~thTrqKKQrkCtFgdSMr9Y-Vj~N-VQJGkVoYWk1wKY9ZNyzOxe0f0JJ8thGV7Jmgw__&Key-Pair-Id=APKAJAG7CPDF7XZTD6SA',
          tags: ['[M]sensor_image.image.tags'],
        },
        alt_text: '[M]sensor_image.alt_text',
      },
      units: [
        {
          metadata: {},
          unit_key: '[M]units.unit_key',
          unit_label: '[M]units.unit_label',
        },
      ],
      table_columns: [
        {
          metadata: {},
          column_key: 'SYS',
          column_label: 'SYS',
        },
        {
          metadata: {},
          column_key: 'DIA',
          column_label: 'DIA',
        },
        {
          metadata: {},
          column_key: 'PULSE',
          column_label: 'Pulse',
        },
      ],
      table_units: [],
      uid: '[M]uid',
      _content_type_uid: 'device_specification',
    },

    {
      metadata: { createdBy: 'system', createdAt: '2023-10-01T00:00:00Z' },
      title: 'Masimo Rx9909',
      identifier: {
        metadata: { createdBy: 'system', createdAt: '2023-10-01T00:00:00Z' },
        identifier: 'MightySatRx-9909',
      },
      sensor_type: 'Pulse Oximeter',
      manufacturer: 'Masimo',
      device_model: 'MightySatRx-9909',
      sensor_image: {
        metadata: { createdBy: 'system', createdAt: '2023-10-01T00:00:00Z' },
        image: {
          metadata: { createdBy: 'system', createdAt: '2023-10-01T00:00:00Z' },
          _version: 1,
          uid: 'img-12345',
          title: 'Marsden MightySatRx-9909 Image',
          filename: 'Device_Photograph_MasimoWhiteBackground_v02.png',
          relative_path: '/images/marsden_m550.jpg',
          content_type: 'image/png',
          file_size: '126122',
          url: 'https://d1cr4mo06ywth1.cloudfront.net/unify/master/unify/master/5ca78ad603a8249d05a0/sensorImage.png?Expires=1723203865&Signature=nPIQFx4FL9TU~klETKGlg--3Gkct75FWUGhPZhQUX9DCnaxiRnzAXV6am68HumA-yuas4fCIjinsz92RmCOqVLs0FH4La7~p3x9DrahWD~Oy2R-y78akgIGAtcrIvCY~vG2YgGlxqOREQFQKLGhH7z2HC-nHmunI9B4Y0fYy7v7bTOGeJuiJuFHeAylMfTcjozbxpbU3RfAOWEC1Z1iG18HbdgiMkrzfaXVvCPM5ZZIp2ocasI4188vFmoHVtfuNTjcJZTXa6DMBTlVULfySBgBkXeHB2~x9vx15NtlC3pWlgDl0H-1Jsy-qngsxkXgFqyqSMCNiAWGHBG9~YYCe3g__&Key-Pair-Id=APKAJAG7CPDF7XZTD6SA',
          tags: ['Pulse Oximeter', 'monitor', 'Masimo'],
        },
        alt_text: 'Marsden MightySatRx-9909 Pulse Oximeter Monitor',
      },
      units: [
        {
          metadata: { createdBy: 'system', createdAt: '2023-10-01T00:00:00Z' },
          unit_key: 'mmHg',
          unit_label: 'Millimeters of Mercury',
        },
      ],
      table_columns: [
        {
          column_key: 'SPO2',
          column_label: 'SPO2',
        },
        {
          column_key: 'PULSE',
          column_label: 'Pulse',
        },
        {
          column_key: 'RR',
          column_label: 'RR',
        },
      ],
      table_units: [
        {
          value_name: 'SPO2',
          units: [
            {
              unit_key: 'perc',
              unit_label: '%',
            },
          ],
        },
        {
          value_name: 'MIN_SPO2',
          units: [
            {
              unit_key: 'perc',
              unit_label: '%',
            },
          ],
        },
        {
          value_name: 'AVG_SPO2',
          units: [
            {
              unit_key: 'perc',
              unit_label: '%',
            },
          ],
        },
        {
          value_name: 'MAX_SPO2',
          units: [
            {
              unit_key: 'perc',
              unit_label: '%',
            },
          ],
        },
        {
          value_name: 'HEART_RATE',
          units: [
            {
              unit_key: 'bpm',
              unit_label: 'bpm',
            },
          ],
        },
        {
          value_name: 'MIN_PULSE_RATE',
          units: [
            {
              unit_key: 'bpm',
              unit_label: 'bpm',
            },
          ],
        },
        {
          value_name: 'AVG_PULSE_RATE',
          units: [
            {
              unit_key: 'bpm',
              unit_label: 'bpm',
            },
          ],
        },
        {
          value_name: 'MAX_PULSE_RATE',
          units: [
            {
              unit_key: 'bpm',
              unit_label: 'bpm',
            },
          ],
        },
        {
          value_name: 'AVERAGE_RESPIRATION_RATE_FROM_PLETH',
          units: [
            {
              unit_key: 'rpm',
              unit_label: 'rpm',
            },
          ],
        },
      ],
      uid: 'device-12345',
      _content_type_uid: 'device_specification',
    },

    {
      metadata: { createdBy: 'system', createdAt: '2023-10-01T00:00:00Z' },
      title: 'MIR Spirobank Smart',
      identifier: {
        metadata: { createdBy: 'system', createdAt: '2023-10-01T00:00:00Z' },
        identifier: 'MIRSpirobankSmart',
      },
      sensor_type: 'Spirometer',
      manufacturer: 'MIR',
      device_model: 'MIRSpirobankSmart',
      sensor_image: {
        metadata: { createdBy: 'system', createdAt: '2023-10-01T00:00:00Z' },
        image: {
          metadata: { createdBy: 'system', createdAt: '2023-10-01T00:00:00Z' },
          _version: 1,
          uid: 'img-12345',
          title: 'Ofrazu_9643_Spirobank_smart_small.png',
          filename: 'Ofrazu_9643_Spirobank_smart_small.png',
          relative_path: '/images/marsden_m550.jpg',
          content_type: 'image/png',
          file_size: '44002',
          url: 'https://d1cr4mo06ywth1.cloudfront.net/unify/master/unify/master/9a1cf3d6acaf4bb0e6dc/sensorImage.png?Expires=1723206870&Signature=c-G5RN14MUY5w8LcrDGw7kVlEb1aD6MV9qiKLHgDHJODp4ulwXPuHpEClQouXPNZmG4JedGXVGBhWc0TiTLAfHjTLdSPljlmNtNi7YZhoYNA5gvkGyiLto2ZAE5H-jG9xz4nY2ztQpgzP7U3SRJgeEGqQboM~8utMYhNGBVWH4izgZzJzgUagQN0t1e-PpiUwCBBHYh3tvGj6S-~hMGKOOa1~~7Q0egdWQSELM7q3TJsVGoe26R15PKOBIh8Wow9tofMN-rUbEF04BRQyx7btM1fmtyUxTHziu4enVO3eot7mYFs6~R5I1z-VvajhXkUeP1aMJT5KT43IRDTPs5NVw__&Key-Pair-Id=APKAJAG7CPDF7XZTD6SA',
          tags: ['Spirometer', 'monitor', 'MIR'],
        },
        alt_text: 'Marsden MightySatRx-9909 Spirometer Monitor',
      },
      units: [
        {
          metadata: { createdBy: 'system', createdAt: '2023-10-01T00:00:00Z' },
          unit_key: 'mmHg',
          unit_label: 'Millimeters of Mercury',
        },
      ],
      table_columns: [
        {
          column_key: 'FEV1',
          column_label: 'FEV1',
        },
        {
          column_key: 'FVC',
          column_label: 'FVC',
        },
        {
          column_key: 'FEV1_DIV_FVC',
          column_label: 'FEV1/FVC',
        },
        {
          column_key: 'PEF',
          column_label: 'PEF',
        },
      ],
      table_units: [
        {
          value_name: 'SPO2',
          units: [
            {
              unit_key: 'perc',
              unit_label: '%',
            },
          ],
        },
        {
          value_name: 'fev1_cL',
          units: [
            {
              unit_key: 'cl',
              unit_label: 'cL',
            },
          ],
        },
        {
          value_name: 'fvc_L',
          units: [
            {
              unit_key: 'l',
              unit_label: 'L',
            },
          ],
        },
        {
          value_name: 'fev1_fvc_pcnt',
          units: [
            {
              unit_key: 'perc',
              unit_label: '%',
            },
          ],
        },
        {
          value_name: 'pef_cLs',
          units: [
            {
              unit_key: 'cl_s',
              unit_label: 'cL/s',
            },
          ],
        },
        {
          value_name: 'fev1_L',
          units: [
            {
              unit_key: 'l',
              unit_label: 'L',
            },
          ],
        },
        {
          value_name: 'pef_Ls',
          units: [
            {
              unit_key: 'l_s',
              unit_label: 'L/s',
            },
          ],
        },
      ],
      uid: 'device-12345',
      _content_type_uid: 'device_specification',
    },
  ],
};

const create = (partial: DeviceSpecificationContentModel[] = []): DeviceSpecificationContentModel[] => [
  ...DeviceSpecificationContentMock['device_specification'],
  ...partial,
];

export const DeviceSpecificationContentModelsMock = { create };
